(() => {
  "use strict";

  const PRODUCTION_SITE_KEY = "0x4AAAAAAE3Tf9w333Tmwyv-";
  const LOCAL_SITE_KEY = "1x00000000000000000000BB";
  const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);
  const SITE_KEY = LOCAL_HOSTNAMES.has(
    window.location.hostname.toLowerCase()
  )
    ? LOCAL_SITE_KEY
    : PRODUCTION_SITE_KEY;
  const SCRIPT_URL =
    "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  const VERIFICATION_MESSAGE =
    "No pudimos validar que eres una persona. Inténtalo de nuevo.";

  let scriptPromise = null;

  const createVerificationError = () => {
    const error = new Error(VERIFICATION_MESSAGE);
    error.code = "TURNSTILE_CLIENT_FAILED";
    return error;
  };

  const loadScript = () => {
    if (window.turnstile) {
      return Promise.resolve(window.turnstile);
    }

    if (scriptPromise) {
      return scriptPromise;
    }

    scriptPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        'script[data-peguu-turnstile-script]'
      );
      const script = existingScript || document.createElement("script");

      const handleLoad = () => {
        if (window.turnstile) {
          resolve(window.turnstile);
          return;
        }

        scriptPromise = null;
        script.remove();
        reject(createVerificationError());
      };

      const handleError = () => {
        scriptPromise = null;
        script.remove();
        reject(createVerificationError());
      };

      script.addEventListener("load", handleLoad, { once: true });
      script.addEventListener("error", handleError, { once: true });

      if (!existingScript) {
        script.src = SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.dataset.peguuTurnstileScript = "true";
        document.head.appendChild(script);
      }
    });

    return scriptPromise;
  };

  const getToken = async (signal) => {
    const turnstile = await loadScript();

    if (signal?.aborted) {
      throw new DOMException("La solicitud fue cancelada.", "AbortError");
    }

    return new Promise((resolve, reject) => {
      const container = document.createElement("div");
      let widgetId = null;
      let settled = false;

      container.className = "peguu-turnstile";
      document.body.appendChild(container);

      const cleanup = () => {
        if (widgetId !== null) {
          try {
            turnstile.reset(widgetId);
            turnstile.remove(widgetId);
          } catch (error) {
            console.warn("No fue posible limpiar Turnstile:", error);
          }
        }

        container.remove();
      };

      const fail = (error) => {
        if (settled) {
          return;
        }

        settled = true;
        signal?.removeEventListener("abort", handleAbort);
        cleanup();
        reject(error);
      };

      const handleAbort = () => {
        fail(new DOMException("La solicitud fue cancelada.", "AbortError"));
      };

      signal?.addEventListener("abort", handleAbort, { once: true });

      try {
        widgetId = turnstile.render(container, {
          sitekey: SITE_KEY,
          execution: "execute",
          appearance: "interaction-only",
          retry: "never",
          "response-field": false,
          callback: (token) => {
            if (settled) {
              return;
            }

            settled = true;
            signal?.removeEventListener("abort", handleAbort);
            resolve({
              token,
              reset: cleanup,
            });
          },
          "error-callback": () => fail(createVerificationError()),
          "expired-callback": () => fail(createVerificationError()),
          "timeout-callback": () => fail(createVerificationError()),
        });

        turnstile.execute(widgetId);
      } catch (error) {
        fail(createVerificationError());
      }
    });
  };

  window.PeguuTurnstile = Object.freeze({
    getToken,
  });
})();
